var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSandWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9961 21.999H19.9961V19.999H18.9961V18.999C18.9942 17.7842 18.6768 16.5907 18.075 15.5354C17.4732 14.4801 16.6077 13.5992 15.5631 12.979C15.2081 12.769 14.9961 12.432 14.9961 12.078V11.92C14.9961 11.566 15.2081 11.229 15.5621 11.02C16.6069 10.3997 17.4726 9.51866 18.0746 8.46321C18.6765 7.40776 18.9941 6.21407 18.9961 4.99902V3.99902H19.9961V1.99902H3.99609V3.99902H4.99609V4.99902C4.99812 6.21407 5.31566 7.40776 5.91763 8.46321C6.51959 9.51866 7.38534 10.3997 8.43009 11.02C8.78409 11.229 8.99609 11.565 8.99609 11.92V12.078C8.99609 12.432 8.78409 12.769 8.43009 12.978C7.38534 13.5984 6.51959 14.4794 5.91763 15.5348C5.31566 16.5903 4.99812 17.784 4.99609 18.999V19.999H3.99609V21.999H18.9961ZM16.9961 3.99902V4.99902C16.9946 6.08127 16.6423 7.13387 15.9921 7.99902H8.00009C7.34988 7.13387 6.99761 6.08127 6.99609 4.99902V3.99902H16.9961ZM9.44609 14.701C10.4171 14.127 10.9961 13.147 10.9961 12.078V11.999H12.9961V12.078C12.9961 13.146 13.5751 14.127 14.5471 14.701C15.4456 15.2358 16.1531 16.0397 16.5691 16.999H7.42309C7.83922 16.0395 8.54706 15.2354 9.44609 14.701Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSandWatch);
export default __webpack_public_path__ + "static/media/ico-sand-watch.179f4557e6b77d70a372bd1e92aa42ec.svg";
export { ForwardRef as ReactComponent };